export const ALL_SPRINT_REQUEST = "allSprint/allSprintRequest";
export const ALL_SPRINT_SUCCESS = "allSprint/allSprintSuccess";
export const ALL_SPRINT_ERROR = "allSprint/allSprintError";